import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6fee2e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-4",
  class: "page-4"
}
const _hoisted_2 = { class: "d-block d-md-none step" }
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "content" }

import ResponsiveImage from '../responsive-image.vue';
import { ref } from 'vue';
import { Modal } from 'bootstrap';
import IconClose from '../icon-close.png';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const modal2_1Ref = ref<HTMLDivElement>();
const modal2_2Ref = ref<HTMLDivElement>();
const modal4_1Ref = ref<HTMLDivElement>();
const modal4_2Ref = ref<HTMLDivElement>();

function showDialog(ele?: HTMLDivElement) {
  if (ele) {
    Modal.getOrCreateInstance(ele, { backdrop: false }).show();
  }
}
function hideDialog(ele?: HTMLDivElement) {
  if (ele) {
    Modal.getOrCreateInstance(ele).hide();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpeg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpeg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 2216,
      "image-w": 3840,
      "mobile-image-h": 1962,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ResponsiveImage, {
        image: require('./step-m.png'),
        "image-webp": require('./step-m.webp')
      }, null, 8, ["image", "image-webp"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "button btn-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog(modal2_1Ref.value)))
      }),
      _createElementVNode("div", {
        class: "button btn-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog(modal4_1Ref.value)))
      })
    ]),
    _createElementVNode("div", {
      ref_key: "modal2_1Ref",
      ref: modal2_1Ref,
      class: "modal fade modal-2-1"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "button-close",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (hideDialog(modal2_1Ref.value)))
          }, [
            _createElementVNode("img", { src: _unref(IconClose) }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "button-next",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog(modal2_2Ref.value)))
            }),
            _createVNode(ResponsiveImage, {
              image: require('./2-1.png'),
              "image-webp": require('./2-1.webp'),
              "mobile-image": require('./2-1-m.png'),
              "mobile-image-webp": require('./2-1-m.webp'),
              "image-w": 1432,
              "image-h": 1398,
              "mobile-image-w": 1068,
              "mobile-image-h": 1296
            }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      ref_key: "modal2_2Ref",
      ref: modal2_2Ref,
      class: "modal fade modal-2-2"
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button-close",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (hideDialog(modal2_2Ref.value)))
          }, [
            _createElementVNode("img", { src: _unref(IconClose) }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(ResponsiveImage, {
              image: require('./2-2.png'),
              "image-webp": require('./2-2.webp'),
              "mobile-image": require('./2-2-m.png'),
              "mobile-image-webp": require('./2-2-m.webp'),
              "image-w": 1854,
              "image-h": 1234,
              "mobile-image-w": 985,
              "mobile-image-h": 2229
            }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      ref_key: "modal4_1Ref",
      ref: modal4_1Ref,
      class: "modal fade modal-4-1"
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "button-close",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (hideDialog(modal4_1Ref.value)))
          }, [
            _createElementVNode("img", { src: _unref(IconClose) }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "button-next",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (showDialog(modal4_2Ref.value)))
            }),
            _createVNode(ResponsiveImage, {
              image: require('./4-1.png'),
              "image-webp": require('./4-1.webp'),
              "mobile-image": require('./4-1-m.png'),
              "mobile-image-webp": require('./4-1-m.webp'),
              "image-w": 1432,
              "image-h": 1398,
              "mobile-image-w": 1068,
              "mobile-image-h": 1296
            }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      ref_key: "modal4_2Ref",
      ref: modal4_2Ref,
      class: "modal fade modal-4-2"
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "button-close",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (hideDialog(modal4_2Ref.value)))
          }, [
            _createElementVNode("img", { src: _unref(IconClose) }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(ResponsiveImage, {
              image: require('./4-2.png'),
              "image-webp": require('./4-2.webp'),
              "mobile-image": require('./4-2-m.png'),
              "mobile-image-webp": require('./4-2-m.webp'),
              "image-w": 1992,
              "image-h": 1794,
              "mobile-image-w": 984,
              "mobile-image-h": 3252
            }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"])
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})